import { AutogenModelAuthDispatchControl, AutogenRowAuthDispatchControl } from "./autogen/AutogenModelAuthDispatchControl";

export class ModelAuthDispatchControl extends AutogenModelAuthDispatchControl<RowAuthDispatchControl> {
    constructor() {
        super(RowAuthDispatchControl);
    }
}

export class RowAuthDispatchControl extends AutogenRowAuthDispatchControl {
}